import OrderManager from "./OrderManager";

export default class OrderManagerMake extends OrderManager
{
    constructor()
    {
        super({});
    }


    displayInputAddressContainer(display = false)
    {
        let parentAddressNode;

        if(parentAddressNode = this.getAddressNode()) {
            parentAddressNode.classList.add("lpost-address-disabled");

            if (display) {
                parentAddressNode.classList.add("lpost-address-disabled");
            } else {
                parentAddressNode.classList.remove("lpost-address-disabled");
            }
        }

        return false;
    }

    getLocationId()
    {
        let locationValue;
        
        if(this.isOrderAjaxComponent('propertyCollection')){
            if(locationValue = BX.Sale.OrderAjaxComponent.propertyCollection.getDeliveryLocation()?.getSettings()?.VALUE[0]) {
                return locationValue;
            }
        }             

        return this.getPropertyValueByCode("LOCATION");
    }

    setProfiles(profiles)
    {
        this.options.profiles = profiles;
    }

    refresh()
    {
        if(this.isOrderAjaxComponent('sendRequest'))
            BX.Sale.OrderAjaxComponent.sendRequest();
    }

    getDeliveryProfileId()
    {
        let delivery = this.getSelectedDelivery();
        return delivery['ID'];
    }

    getSelectedDeliveryProfile()
    {
        return this.getSelectedDelivery();
    }

    getSelectedDelivery()
    {
        if(this.isOrderAjaxComponent('getSelectedDelivery')) //&& typeof BX.Sale.OrderAjaxComponent.getSelectedDelivery != 'undefined'
            return BX.Sale.OrderAjaxComponent.getSelectedDelivery();
        else if(document.querySelector('input[name=DELIVERY_ID]:checked'))
            return { 'ID' : document.querySelector('input[name=DELIVERY_ID]:checked').value};
    }

    renderAddress(value)
    {
        if(this.isOrderAjaxComponent('propertyCollection')){
            let addressObject;

            if(addressObject = this.getAddressObject()) {
                addressObject.setValue(value);
            }
        }
        else{
            
            let prop = this.getPropField('ADDRESS');
            if(prop)
                prop.value = value;
        }
    }

    renderAdditionalField(value, code)
    {
        
        if(this.isOrderAjaxComponent('propertyCollection')){
        
            let propertyId = this.getPropertyIdByCode(code);

            if(propertyId) {
                let fieldObject = BX.Sale.OrderAjaxComponent.propertyCollection.getById(propertyId);
                fieldObject.setValue(value);
            }
        }
        else{
  
            let prop = this.getPropField(code);
            if(prop)
                prop.value = value;
        }
    }
    
    getPropField(code)
    {
        let propsOrder = this.getPropertyFieldByCodeByTypeBuyerId(this.getPersonTypeId(), code);
        if(propsOrder['ID']){
            
            if(document.querySelector('[name="ORDER_PROP_' + propsOrder['ID'] + '"]'))
                return document.querySelector('[name="ORDER_PROP_' + propsOrder['ID'] + '"]');
            
            if(document.querySelector('[name="' + propsOrder['CODE'] + '"]'))
                return document.querySelector('[name="' + propsOrder['CODE'] + '"]');
        }
        return false;
    }

// .querySelectorAll('.input-date-day-delivery').forEach(elem => elem.value = e.target.value);
    getPersonTypeId()
    {
        let personTypeId;
        
        if(this.isOrderAjaxComponent('getSelectedPersonType') && BX.Sale.OrderAjaxComponent.getSelectedPersonType()?.ID)
            personTypeId = BX.Sale.OrderAjaxComponent.getSelectedPersonType().ID;
        
        else{
            if(document.querySelector('input[name="PERSON_TYPE"]:checked'))
                personTypeId = document.querySelector('input[name="PERSON_TYPE"]:checked').value;
            else if (document.querySelector('input[name="PERSON_TYPE"]'))
                personTypeId = document.querySelector('input[name="PERSON_TYPE"]').value;
            else{
                
                personTypeId = Object.keys(this.propertyFields)[0];
            }
        }
        
        return personTypeId ?? false;
    }

    getAddressObject()
    {
        let addressObject;
            
        if(this.isOrderAjaxComponent('propertyCollection')){
            
            addressObject = BX.Sale
            .OrderAjaxComponent
            .propertyCollection
            .getAddress();

            if(addressObject) {
                return addressObject
            }
            else {
                let propertyId;

                if(propertyId = this.getPropertyIdByCode("ADDRESS", true)) {
                    return BX.Sale.OrderAjaxComponent.propertyCollection.getById(propertyId);
                }
            }
        }
        else{
            
            return this.getPropField('ADDRESS');
        }

        return false;
    }

    getAddressNode()
    {
        
        if(this.isOrderAjaxComponent('propertyCollection')){
            let addressObject;

            if(addressObject = this.getAddressObject()) {
                return this.getAddressObject().getParentNode();
            }
        }
        else{
            
            let prop = this.getPropField('ADDRESS');
            if(prop)
                return prop.parentNode;
        }

        return false;
    }


    setPropertyFields(propertyFields)
    {
        this.propertyFields = propertyFields;
    }

    getPropertyFields()
    {
        return this.propertyFields;
    }

    getPropertyFieldsByTypeBuyerId(typeBuyerId)
    {
        return this.propertyFields[typeBuyerId];
    }

    getPropertyFieldByCodeByTypeBuyerId(typeBuyerId, code)
    {
        return this.propertyFields[typeBuyerId][code] ?? false;
    }

    getPropertyValueByCode(code)
    {
        if(this.isOrderAjaxComponent('result')){
        
            let propsOrder = BX.Sale.OrderAjaxComponent.result.ORDER_PROP.properties;

            for (let prop of propsOrder) {
                if (prop.CODE == this.getPropertyFieldByCodeByTypeBuyerId(this.getPersonTypeId(), code)['CODE']) {
                    return prop.VALUE[0];
                }
            }
        }
        else{
            
            let propsOrder = this.getPropertyFieldByCodeByTypeBuyerId(this.getPersonTypeId(), code);
            if(propsOrder['ID']){
                
                let prop = this.getPropField(code);
                if(prop)
                    return prop.value;
            }
        }

        return false;
    }

    getPropertyIdByCode(code, considering_buyer_id = false)
    {
        return this.getPropertyFieldByCodeByTypeBuyerId(this.getPersonTypeId(), code)['ID'];
        
        /*if (considering_buyer_id) {
            code = this.getPropertyFieldByCodeByTypeBuyerId(this.getPersonTypeId(), code)['CODE'];
        }
        let propsOrder = BX.Sale.OrderAjaxComponent.result.ORDER_PROP.properties;

        for (let prop of propsOrder) {
            if (prop.CODE == code) {
                return prop.ID
            }
        }

        return false;*/
    }
    
    isOrderAjaxComponent(field = null)
    {
        return field == null ? typeof BX.Sale.OrderAjaxComponent != 'undefined' :
                               typeof BX.Sale.OrderAjaxComponent != 'undefined' && BX.Sale.OrderAjaxComponent.hasOwnProperty(field); //typeof BX.Sale.OrderAjaxComponent.field != 'undefined'  field == 'function'
    }
}